/** Treat missing `isActive` as active; only explicit `false` is inactive. */
export function isActiveLookupItem(item: unknown): boolean {
  if (item == null || typeof item !== 'object') return true;
  if (!('isActive' in item)) return true;
  return (item as { isActive?: boolean | null }).isActive !== false;
}
